(function () {
  var E = window.PairingEngine;
  var dataEl = document.getElementById('PairingKitData');
  var root = document.querySelector('[data-pairing-kit]');
  if (!E || !dataEl || !root) return;
  var DATA = JSON.parse(dataEl.textContent);
  var MAX = 3;
  var COMMON_SUBS = ['モルタル・コンクリート', '合板', 'せっこうボード', 'けい酸カルシウム板', '既存タイル'];
  var cache = {};

  (function () {
    var q = document.querySelector('form[data-type="add-to-cart-form"] [name="quantity"]');
    if (!q || !window.MutationObserver) return;
    function fix() {
      var min = parseInt(q.getAttribute('min'), 10), max = parseInt(q.getAttribute('max'), 10);
      if (!(min < 0 || max < 0)) return;
      q.setAttribute('min', '0');
      q.removeAttribute('max');
      if ((parseInt(q.value, 10) || 0) < 0) q.value = '0';
    }
    new MutationObserver(fix).observe(q, { attributes: true, attributeFilter: ['min', 'max'] });
    fix();
  })();

  var tile = {
    title: root.dataset.title, material: root.dataset.material, size: root.dataset.size,
    format: root.dataset.format, cat3: root.dataset.cat3, vendor: root.dataset.vendor
  };
  var types = E.classifyTile(tile);
  var side = E.maxSide(tile.size);
  var dims = E.tileDims(tile.size, root.dataset.thickness, types, tile.format);
  var JOINT_DEFAULT = 4;
  var perM2 = parseFloat(String(root.dataset.perM2 || '').replace(/[^\d.]/g, ''));
  var unit = root.dataset.unit || '';
  var PLACES = E.placesFor(DATA, JSON.parse(root.dataset.uses || '[]'));
  if (!PLACES.length) { root.hidden = true; return; }
  function placeOk(p) { return !!E.approved(DATA, p, null, types, side) || E.approvedSubs(DATA, p, types, side).length > 0; }
  var ANY_OK = (DATA.exclude || []).indexOf(root.dataset.handle) === -1 && PLACES.some(placeOk);
  var calcInput = document.querySelector('.title-calculation .calc-base input');

  function el(tag, attrs, text) {
    var n = document.createElement(tag);
    for (var k in attrs || {}) {
      if (k === 'class') n.className = attrs[k];
      else if (k in n && typeof attrs[k] !== 'string') n[k] = attrs[k];
      else n.setAttribute(k, attrs[k]);
    }
    if (text != null) n.textContent = text;
    return n;
  }
  function yen(cents) { return Math.round(cents / 100).toLocaleString('ja-JP') + '円'; }
  function track(event, extra) {
    window.dataLayer = window.dataLayer || [];
    var o = { event: event }; for (var k in extra || {}) o[k] = extra[k];
    window.dataLayer.push(o);
  }
  function tileForm() { return document.querySelector('form[data-type="add-to-cart-form"]'); }
  function tileVariantId() { var f = tileForm(); var i = f && f.querySelector('[name="id"]'); return i ? i.value : null; }

  function chips(container, items, current, onPick) {
    container.innerHTML = '';
    items.forEach(function (it) {
      var b = el('button', { type: 'button', class: it.icon ? 'pk__place' : 'pk__chip', role: 'radio', 'aria-checked': String(it.value === current) });
      if (it.icon) b.appendChild(el('img', { src: it.icon, alt: '', width: '44', height: '44' }));
      b.appendChild(el('span', null, it.label));
      b.addEventListener('click', function () { onPick(it.value); });
      container.appendChild(b);
    });
  }

  function askBox(text, placeKey) {
    var box = el('div', { class: 'pk__ask' });
    box.appendChild(el('p', null, text));
    var a = el('a', { href: '/pages/contact', class: 'pk__btn' }, '接着剤・目地材について問い合わせる');
    a.addEventListener('click', function () { track('pairing_kit_inquiry', { pk_place: placeKey || '' }); });
    box.appendChild(a);
    return box;
  }

  function fetchProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function optionList(item) {
    return Promise.all(item.products.map(function (p) {
      return fetchProduct(p.handle).then(function (js) {
        if (!js) return [];
        var BASE = /^(オプション無し|Default Title)$/;
        var vs = js.variants.some(function (v) { return BASE.test(v.title); })
          ? js.variants.filter(function (v) { return !/^セット販売/.test(v.title); }) : js.variants;
        return vs.map(function (v) {
          var vt = vs.length > 1 && !BASE.test(v.title) ? v.title : '';
          return { variantId: v.id, label: [p.label, vt].filter(Boolean).join(' ') || js.title, price: v.price,
            available: v.available, image: (v.featured_image && v.featured_image.src) || js.featured_image, meta: p };
        });
      });
    })).then(function (lists) { return [].concat.apply([], lists); });
  }

  function shell() {
    var box = el('div');
    box.innerHTML = '<div class="pk__step"><p class="pk__label">1. どこに張りますか？</p><div class="pk__places" data-pk-places role="radiogroup"></div></div>' +
      '<div class="pk__step" data-pk-sub-step hidden><p class="pk__label">2. 張る面（下地）は何ですか？</p><div class="pk__chips" data-pk-subs role="radiogroup"></div></div>' +
      '<div data-pk-results hidden></div>';
    return box;
  }

  function Kit(container, mode, init) {
    var self = this;
    var state = { place: init.place || null, sub: init.sub || null, area: init.area || 0, moreSubs: false, joint: init.joint || JOINT_DEFAULT };
    var $ = function (sel) { return container.querySelector(sel); };
    var placesEl = $('[data-pk-places]'), subsEl = $('[data-pk-subs]'), results = $('[data-pk-results]');
    var areaStep = $('[data-pk-area-step]');
    var areaInput = mode === 'inline' ? (calcInput || $('[data-pk-area]')) : null;
    var seq = 0;
    var places = mode === 'modal' ? PLACES.filter(placeOk) : PLACES;
    function owned(item) { return item.products.some(function (p) { return (init.inCart || {})[p.handle]; }); }
    self.state = state;

    function readArea() { var v = parseFloat(areaInput.value); state.area = isFinite(v) && v > 0 ? v : 0; }
    function tileQty() {
      if (state.area > 0 && perM2 > 0) return Math.ceil(state.area * perM2);
      var f = tileForm(); var q = f && f.querySelector('[name="quantity"]');
      return Math.max(1, parseInt(q && q.value, 10) || 1);
    }

    function renderPlaces() {
      chips(placesEl, places.map(function (p) { return { value: p.key, label: p.label, icon: p.icon }; }), state.place && state.place.key, function (key) {
        state.place = places.filter(function (p) { return p.key === key; })[0];
        state.sub = null; state.moreSubs = false;
        renderPlaces(); renderSubs(); render();
      });
    }

    function renderSubs() {
      var step = $('[data-pk-sub-step]');
      if (!state.place) { step.hidden = true; return; }
      var subs = E.approvedSubs(DATA, state.place, types, side).map(function (s) { return { value: s, label: s }; });
      if (!subs.length) { step.hidden = true; state.sub = '__unknown'; return; }
      var common = subs.filter(function (s) { return COMMON_SUBS.indexOf(s.value) !== -1; });
      var rest = subs.filter(function (s) { return COMMON_SUBS.indexOf(s.value) === -1; });
      var showAll = state.moreSubs || !common.length || state.sub === '__other' || rest.some(function (s) { return s.value === state.sub; });
      var list = showAll ? subs : common;
      if (!showAll && rest.length) list.push({ value: '__more', label: 'その他の下地' });
      else list.push({ value: '__other', label: '上記以外の下地' });
      list.push({ value: '__unknown', label: 'わからない' });
      step.hidden = false;
      chips(subsEl, list, state.sub, function (v) {
        if (v === '__more') { state.moreSubs = true; renderSubs(); return; }
        state.sub = v; renderSubs(); render();
      });
    }

    function itemRow(item, opts, checked) {
      var row = el('div', { class: 'pk__item' });
      var firstAvail = opts.filter(function (o) { return o.available; })[0] || opts[0];
      var cb = el('input', { type: 'checkbox', 'aria-label': item.name + 'をカートに入れる' });
      cb.checked = checked && !!firstAvail && firstAvail.available;
      var img = el('img', { alt: '', width: '64', height: '64' });
      var body = el('div');
      var name = el('div', { class: 'pk__name' }, item.name);
      if (cb.checked) name.appendChild(el('span', { class: 'pk__badge' }, 'おすすめ'));
      if (owned(item)) name.appendChild(el('span', { class: 'pk__owned' }, 'カートに入っています'));
      name.appendChild(el('div', { class: 'pk__maker' }, item.maker));
      var line = el('div', { class: 'pk__row' });
      var sel = el('select', { 'aria-label': item.name + 'の種類' });
      opts.forEach(function (o, i) {
        var op = el('option', { value: String(i) }, o.label + (o.available ? '' : '（在庫なし）'));
        if (!o.available) op.disabled = true;
        sel.appendChild(op);
      });
      sel.value = String(Math.max(0, opts.indexOf(firstAvail)));
      if (opts.length < 2) sel.hidden = true;
      var qty = el('input', { class: 'pk__qty', type: 'number', min: '1', step: '1', inputmode: 'numeric', value: '1', 'aria-label': '数量' });
      var price = el('span', { class: 'pk__price' });
      var est = el('span', { class: 'pk__est' });
      line.appendChild(sel); line.appendChild(qty); line.appendChild(price); line.appendChild(est);
      body.appendChild(name); body.appendChild(line);
      row.appendChild(cb); row.appendChild(img); row.appendChild(body);

      var packSizes = {};
      opts.forEach(function (o) { if (o.meta.packKg) packSizes[o.meta.packKg] = 1; });
      var sizeChoice = Object.keys(packSizes).length > 1, touched = false;
      function cheapest() {
        var best = null;
        opts.forEach(function (o, i) {
          var p = o.available && E.packs(o.meta, state.area, usage());
          if (p && (!best || o.price * p.qty < best.cost)) best = { i: i, cost: o.price * p.qty };
        });
        return best;
      }
      function current() { return opts[parseInt(sel.value, 10)] || firstAvail; }
      function usage() { return item.joint ? E.groutUsage(item, dims, state.joint) : undefined; }
      function sync(auto) {
        if (auto && sizeChoice && !touched) { var c = cheapest(); if (c) sel.value = String(c.i); }
        var o = current();
        if (!o) return;
        img.src = o.image ? o.image + (o.image.indexOf('?') > -1 ? '&' : '?') + 'width=128' : '';
        price.textContent = yen(o.price);
        var p = E.packs(o.meta, state.area, usage());
        if (p) {
          est.textContent = item.joint
            ? '目安: 約' + p.kg + 'kg（目地幅' + state.joint + 'mm・目地の深さ' + dims.t + 'mmで計算）'
            : '目安: 約' + p.kg + 'kg（標準使用量の上限で計算）';
          if (auto) qty.value = String(p.qty);
        } else {
          est.textContent = state.area > 0 ? '使用量は施工条件で変わるため、数量はご確認ください' : '';
        }
        if (!o.available) cb.checked = false;
        cb.disabled = !o.available;
        update();
      }
      sel.addEventListener('change', function () { touched = true; sync(true); });
      qty.addEventListener('input', update);
      cb.addEventListener('change', update);
      row._pk = { cb: cb, qty: qty, current: current, sync: sync, joint: !!item.joint };
      sync(true);
      return row;
    }

    function render() {
      var my = ++seq;
      if (!state.place || !state.sub) { results.hidden = true; if (areaStep) areaStep.hidden = true; return; }
      if (areaStep) areaStep.hidden = !!calcInput;
      var sub = state.sub === '__unknown' ? null : state.sub;
      var ok = E.approved(DATA, state.place, sub, types, side);
      results.hidden = false;
      if (!ok) {
        results.innerHTML = '';
        results.appendChild(askBox('この張る場所' + (sub ? 'と下地' : '') + 'の組み合わせは、施工条件によって合う接着剤・目地材が変わります。お問い合わせいただければ、当店からご案内します。', state.place.key));
        return;
      }
      var groups = [
        { title: '接着剤', items: ok.adhesives.slice(0, MAX) },
        { title: '目地材', items: ok.grouts.slice(0, MAX) }
      ];
      results.innerHTML = '<p class="pk__lead">読み込み中…</p>';
      Promise.all(groups.map(function (g) {
        return Promise.all(g.items.map(function (it) { return optionList(it).then(function (o) { return { item: it, opts: o }; }); }));
      })).then(function (loaded) {
        if (my !== seq) return;
        results.innerHTML = '';
        loaded.forEach(function (list, gi) {
          var box = el('div', { class: 'pk__group' });
          box.appendChild(el('h3', null, groups[gi].title));
          if (gi === 1 && dims && list.some(function (x) { return x.item.joint; })) box.appendChild(jointInput());
          var shown = list.filter(function (x) { return x.opts.length; });
          if (!shown.length) box.appendChild(el('p', { class: 'pk__none' }, 'この条件に合う' + groups[gi].title + 'は当店の取り扱いにありません。お問い合わせください。'));
          shown.forEach(function (x, i) { box.appendChild(itemRow(x.item, x.opts, i === 0 && !owned(x.item))); });
          results.appendChild(box);
        });
        var foot = el('div', { class: 'pk__foot' });
        if (mode === 'inline' && calcInput) foot.appendChild(el('p', { class: 'pk__basis', 'data-pk-basis': '' }));
        if (mode === 'inline') {
          var tl = el('label', { class: 'pk__tile' });
          var tcb = el('input', { type: 'checkbox', 'data-pk-tile': '' }); tcb.checked = true;
          tcb.addEventListener('change', update);
          tl.appendChild(tcb); tl.appendChild(el('span', { 'data-pk-tile-text': '' }));
          foot.appendChild(tl);
        }
        foot.appendChild(el('div', { class: 'pk__sum', 'data-pk-sum': '' }));
        var btn = el('button', { type: 'button', class: 'pk__btn', 'data-pk-add': '' }, mode === 'inline' ? 'まとめてカートに入れる' : '選んだ商品もカートに入れる');
        btn.addEventListener('click', addAll);
        foot.appendChild(btn);
        foot.appendChild(el('p', { class: 'pk__err', 'data-pk-err': '', hidden: true }));
        results.appendChild(foot);
        update();
      });
    }

    function jointInput() {
      var wrap = el('label', { class: 'pk__joint' });
      wrap.appendChild(el('span', null, '目地幅'));
      var inp = el('input', { type: 'number', min: '1', max: '20', step: '0.5', inputmode: 'decimal', value: String(state.joint), 'aria-label': '目地幅（mm）' });
      wrap.appendChild(inp);
      wrap.appendChild(el('span', null, 'mm'));
      inp.addEventListener('input', function () {
        var v = parseFloat(inp.value);
        if (!(v > 0 && v <= 20)) return;
        state.joint = v;
        rows().forEach(function (r) { if (r.joint) r.sync(true); });
        update();
      });
      return wrap;
    }

    function rows() { return Array.prototype.map.call(results.querySelectorAll('.pk__item'), function (r) { return r._pk; }).filter(Boolean); }

    function update() {
      var sum = results.querySelector('[data-pk-sum]');
      if (!sum) return;
      var basis = results.querySelector('[data-pk-basis]');
      if (basis) {
        basis.innerHTML = '';
        basis.appendChild(document.createTextNode('数量は上の「注文必要数」の ' + (state.area || 0) + 'm² で計算しています。'));
        var jump = el('button', { type: 'button' }, '面積を変更する');
        jump.addEventListener('click', function () { calcInput.scrollIntoView({ behavior: 'smooth', block: 'center' }); calcInput.focus({ preventScroll: true }); calcInput.select(); });
        basis.appendChild(jump);
      }
      var tileText = results.querySelector('[data-pk-tile-text]');
      if (tileText) tileText.textContent = 'このタイルも一緒に入れる（' + tileQty() + (unit || '点') + (state.area > 0 && perM2 > 0 ? '・' + state.area + 'm²分' : '') + '）';
      var n = 0, total = 0;
      rows().forEach(function (r) {
        if (!r.cb.checked) return;
        n += 1; total += r.current().price * Math.max(1, parseInt(r.qty.value, 10) || 1);
      });
      sum.textContent = n ? '接着剤・目地材 ' + n + '点 小計 ' + yen(total) + '（税込）' : '接着剤・目地材が選ばれていません';
      var tcb = results.querySelector('[data-pk-tile]');
      results.querySelector('[data-pk-add]').disabled = !n && !(tcb && tcb.checked);
    }

    function addAll() {
      var btn = results.querySelector('[data-pk-add]'), err = results.querySelector('[data-pk-err]');
      var label = btn.textContent;
      var items = [];
      var tcb = results.querySelector('[data-pk-tile]');
      if (tcb && tcb.checked && tileVariantId()) items.push({ id: Number(tileVariantId()), quantity: tileQty() });
      rows().forEach(function (r) {
        if (!r.cb.checked) return;
        items.push({ id: r.current().variantId, quantity: Math.max(1, parseInt(r.qty.value, 10) || 1), properties: { _pairing_kit: (mode === 'modal' ? 'popup:' : '') + state.place.key } });
      });
      if (!items.length) return;
      btn.disabled = true; err.hidden = true; btn.textContent = 'カートに追加しています…';
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'カートに追加できませんでした');
          track(mode === 'modal' ? 'pairing_popup_add' : 'pairing_kit_add', { pk_place: state.place.key, pk_items: items.length });
          window.location.href = '/cart';
        })
        .catch(function (e) {
          err.textContent = e.message; err.hidden = false;
          btn.disabled = false; btn.textContent = label;
        });
    }

    self.refreshArea = function () { readArea(); rows().forEach(function (r) { r.sync(true); }); update(); };
    self.update = update;

    if (areaInput) {
      readArea();
      areaInput.addEventListener('input', self.refreshArea);
    }
    if (!state.place && places.length === 1) state.place = places[0];
    renderPlaces(); renderSubs(); render();
  }

  if (!ANY_OK) {
    Array.prototype.forEach.call(root.querySelectorAll('.pk__step, .pk__lead, .pk__note'), function (n) { n.hidden = true; });
    var res = root.querySelector('[data-pk-results]');
    res.hidden = false;
    res.appendChild(askBox('このタイルに合う接着剤・目地材は、張る場所や下地によって変わります。お問い合わせいただければ、当店からご案内します。', ''));
    return;
  }

  var inline = new Kit(root, 'inline', {});
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'quantity' && e.target.closest('form[data-type="add-to-cart-form"]')) inline.update();
  });

  function carried() {
    var s = inline.state;
    if (!s.place || !placeOk(s.place)) return { place: null, sub: null };
    if (!s.sub || !E.approved(DATA, s.place, s.sub === '__unknown' ? null : s.sub, types, side)) return { place: s.place, sub: null };
    return { place: s.place, sub: s.sub };
  }

  var HANDLES = {};
  DATA.adhesives.concat(DATA.grouts).forEach(function (g) { g.products.forEach(function (p) { HANDLES[p.handle] = 1; }); });

  function setCartCount(n) {
    Array.prototype.forEach.call(document.querySelectorAll('cart-count'), function (c) { c.textContent = n; c.hidden = false; c.classList.remove('hidden'); });
  }

  function openModal(line, cart) {
    var qty = line.quantity;
    var area = perM2 > 0 ? Math.round((qty / perM2) * 10) / 10 : 0;
    var modal = el('div', { class: 'pk-modal', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'pk-modal-title', 'data-pk-modal': '' });
    var panel = el('div', { class: 'pk-modal__panel' });
    var close = el('button', { type: 'button', class: 'pk-modal__close', 'aria-label': '閉じる' });
    close.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true"><path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="1.8"/></svg>';
    var done = el('div', { class: 'pk-modal__done' });
    var thumb = el('img', { alt: '', width: '56', height: '56', src: line.image ? line.image + (line.image.indexOf('?') > -1 ? '&' : '?') + 'width=112' : '' });
    var info = el('div');
    info.appendChild(el('p', { class: 'pk-modal__status' }, 'カートに追加しました'));
    info.appendChild(el('p', { class: 'pk-modal__tile' }, line.product_title + '　' + qty + (unit || '点')));
    done.appendChild(thumb); done.appendChild(info);
    var title = el('h2', { class: 'tile-p-sub-title', id: 'pk-modal-title' }, '推奨の副資材');
    var lead = el('p', { class: 'pk__lead' }, area > 0
      ? 'カートのタイル ' + qty + (unit || '点') + '（約' + area + 'm²分）をもとに数量を計算しています。'
      : '施工箇所、下地を選択して下さい。接着剤・目地材を用途に合わせてご提案いたします。');
    var body = shell();
    var skip = el('a', { href: '/cart', class: 'pk-modal__skip', 'data-pk-skip': '' }, '選択せずに購入');
    panel.appendChild(close); panel.appendChild(done); panel.appendChild(title); panel.appendChild(lead);
    panel.appendChild(body); panel.appendChild(skip);
    modal.appendChild(el('div', { class: 'pk-modal__backdrop', 'data-pk-close': '' }));
    modal.appendChild(panel);
    document.body.appendChild(modal);
    document.documentElement.classList.add('pk-modal-open');
    var init = carried();
    var inCart = {};
    cart.items.forEach(function (i) { if (HANDLES[i.handle]) inCart[i.handle] = 1; });
    new Kit(body, 'modal', { place: init.place, sub: init.sub, area: area, inCart: inCart, joint: inline.state.joint });
    setCartCount(cart.item_count);
    track('pairing_popup_view', { pk_place: init.place ? init.place.key : '' });

    var last = document.activeElement;
    function shut() {
      modal.remove();
      document.documentElement.classList.remove('pk-modal-open');
      document.removeEventListener('keydown', onKey);
      if (last && last.focus) last.focus();
    }
    function onKey(e) { if (e.key === 'Escape') shut(); }
    close.addEventListener('click', shut);
    modal.addEventListener('click', function (e) { if (e.target === modal || e.target.hasAttribute('data-pk-close')) shut(); });
    document.addEventListener('keydown', onKey);
    close.focus();
  }

  function syncQuantityRules(form, cart) {
    var q = form.querySelector('[name="quantity"]'), id = form.querySelector('[name="id"]');
    if (!q || !id) return;
    var inCart = 0;
    cart.items.forEach(function (i) { if (String(i.variant_id) === String(id.value)) inCart += i.quantity; });
    q.setAttribute('data-cart-quantity', String(inCart));
    var qi = q.closest('quantity-input');
    if (qi && typeof qi.setQuantityBoundries === 'function') qi.setQuantityBoundries({ data: { sectionId: qi.sectionId, productId: qi.productId } });
  }

  function stockOk(form) {
    var q = form.querySelector('[name="quantity"]');
    if (!q || !q.hasAttribute('data-max')) return true;
    var rest = parseInt(q.getAttribute('data-max'), 10) - (parseInt(q.getAttribute('data-cart-quantity'), 10) || 0);
    var n = parseInt(q.value, 10) || 0;
    if (!isFinite(rest) || n <= rest) return true;
    q.setCustomValidity(rest > 0 ? '在庫が足りません。あと' + rest + '点まで追加できます。' : '在庫分はすべてカートに入っています。');
    q.reportValidity();
    q.addEventListener('input', function clear() { q.setCustomValidity(''); q.removeEventListener('input', clear); });
    return false;
  }

  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    if (form.querySelector('[name^="properties"], [class*="globo"], [id*="globo"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!stockOk(form)) return;
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    var fd = new FormData(form);
    var added = false;
    function native() { HTMLFormElement.prototype.submit.call(form); }
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { native(); return; }
        added = true;
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
          syncQuantityRules(form, cart);
          openModal(res.j, cart);
        });
      })
      .catch(function (err) {
        if (window.console) console.error('[pairing-kit]', err);
        if (added) window.location.href = '/cart'; else native();
      })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }, true);
})();
